// extracted by mini-css-extract-plugin
module.exports = {"ThankYou":"ThankYou_ThankYou__Um8wg","animation":"ThankYou_animation__E5jnI","text":"ThankYou_text__59ieL","completed":"ThankYou_completed__7HmwA"};